import React, { useState } from 'react';
import { Button, Group, Popover, Stack, Text } from '@mantine/core';
import { IconColumns3 } from '@tabler/icons-react';
import {
  GanttGridColumnToggles,
  type GanttVisibleOptionalColumns,
} from './GanttGridColumnToggles';
import { ganttToolbarButtonProps } from './ganttToolbarStyles';

export interface GanttColumnsMenuProps {
  value: GanttVisibleOptionalColumns;
  onChange: React.Dispatch<React.SetStateAction<GanttVisibleOptionalColumns>>;
}

/** Always-visible Columns control on the primary Gantt toolbar. */
export function GanttColumnsMenu({ value, onChange }: GanttColumnsMenuProps) {
  const [opened, setOpened] = useState(false);

  return (
    <Popover
      opened={opened}
      onChange={setOpened}
      shadow="md"
      radius="md"
      position="bottom-end"
      offset={8}
      withinPortal
    >
      <Popover.Target>
        <Button
          {...ganttToolbarButtonProps}
          variant="default"
          type="button"
          leftSection={<IconColumns3 size={14} stroke={1.75} />}
          onClick={() => setOpened((o) => !o)}
          aria-label="Columns"
          aria-expanded={opened}
        >
          Columns
        </Button>
      </Popover.Target>
      <Popover.Dropdown
        className="gantt-columns-popover"
        p={0}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="gantt-columns-popover-body">
          <Group justify="space-between" align="center" px={12} pt={10} pb={6} wrap="nowrap">
            <Text size="sm" fw={600}>
              Columns
            </Text>
          </Group>
          <Stack gap={0} px={6} pb={6}>
            <GanttGridColumnToggles variant="checkbox" value={value} onChange={onChange} compact />
          </Stack>
        </div>
      </Popover.Dropdown>
    </Popover>
  );
}
